var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed inset-0 z-50 flex p-6 overflow-y-auto bg-smoke-light"},[_c('on-escape',{attrs:{"execute":_vm.close}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }